import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { branchService } from '../services/branchService';
import toast from 'react-hot-toast';

export const useBranches = () => {
  return useQuery(
    ['branches'],
    branchService.getBranches,
    {
      staleTime: 300000 // 5 minutes
    }
  );
};

export const useBranch = (branchId) => {
  return useQuery(
    ['branch', branchId],
    () => branchService.getBranch(branchId),
    {
      enabled: !!branchId,
      staleTime: 300000
    }
  );
};

export const useCreateBranch = () => {
  const queryClient = useQueryClient();

  return useMutation(branchService.createBranch, {
    onSuccess: () => {
      queryClient.invalidateQueries(['branches']);
      toast.success('Branch created successfully');
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || 'Failed to create branch');
    }
  });
};

export const useUpdateBranch = () => {
  const queryClient = useQueryClient();

  return useMutation(
    ({ branchId, data }) => branchService.updateBranch(branchId, data),
    {
      onSuccess: (data, variables) => {
        queryClient.invalidateQueries(['branch', variables.branchId]);
        queryClient.invalidateQueries(['branches']);
        toast.success('Branch updated successfully');
      },
      onError: (error) => {
        toast.error(error.response?.data?.message || 'Failed to update branch');
      }
    }
  );
};

export const useDeleteBranch = () => {
  const queryClient = useQueryClient();

  return useMutation(branchService.deleteBranch, {
    onSuccess: () => {
      queryClient.invalidateQueries(['branches']);
      toast.success('Branch deleted successfully');
    },
    onError: (error) => {
      toast.error(error.response?.data?.message || 'Failed to delete branch');
    }
  });
};